import type { Authentication } from "@/lib/authentication"
import { hasSupportedProviderId } from "@/lib/authentication/hasSupportedProviderId"

export const getAuthenticationProviderId = ({
  authUser,
}: {
  authUser: Authentication.User | void
}): Authentication.ProviderId | void => {
  if (!authUser) {
    return
  }

  const supportedProvider = authUser.providerData.find(hasSupportedProviderId)

  return supportedProvider?.providerId as Authentication.ProviderId
}
